export default __webpack_public_path__ + "static/media/name-dark.0f6c0229.svg";